<template>
  <div
    class="control"
    :class="{ 'is-expanded': expanded, 'has-icons-left': icon }"
  >
    <span class="select" :class="spanClasses">

      <select
        ref="select"
        v-model="computedValue"
        :multiple="multiple"
        :size="nativeSize"
        v-bind="boundAttrs"
        @blur="$emit('blur', $event) && checkHtml5Validity()"
        @focus="$emit('focus', $event)"
      >

        <template v-if="placeholder">
          <option
            v-if="computedValue == null"
            :value="null"
            disabled
            hidden
          >
            {{ placeholder }}
          </option>
        </template>
        <slot />

      </select>
    </span>

    <d-icon
      v-if="icon"
      class="is-left"
      :icon="icon"
      :pack="iconPack"
      :size="iconSize"
    />
  </div>
</template>

<script>
  import { defineComponent } from 'vue';
  import DIcon from '../DIcon/DIcon.vue';
  import FormElementMixin from '../../../utils/mixins/formElementMixin';
  import { attribsWithoutClass } from '../../../utils/vue-helpers';
  export default defineComponent({
    name: 'DSelect',
    emits: ['blur', 'focus', 'update:modelValue'],
    components: {
      DIcon,
    },
    mixins: [FormElementMixin],
    inheritAttrs: false,
    props: {
      modelValue: {
        type: [String, Number, Boolean, Object, Array, Symbol, Function],
        default: null,
      },
      placeholder: String,
      multiple: Boolean,
      nativeSize: [String, Number],
    },
    data() {
      return {
        _elementRef: 'select',
      };
    },
    computed: {
      boundAttrs() {
        return attribsWithoutClass(this.$attrs);
      },
      computedValue: {
        get() {
          return this.modelValue;
        },
        set(value) {
          this.$emit('update:modelValue', value);
          !this.isValid && this.checkHtml5Validity();
        },
      },
      spanClasses() {
        return [this.size, this.statusType, {
          'is-fullwidth': this.expanded,
          'is-loading': this.loading,
          'is-multiple': this.multiple,
          'is-rounded': this.rounded,
          'is-empty': this.modelValue === null,
        }];
      },
    },
  });
</script>